/// <reference path="./GamePayTable.ts" />
import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { AppEvent } from "@lib/titan2/dist/game/Constants";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { MouseUtil } from "@lib/titan2/dist/util/view/MouseUtil";
import { GamePayTable } from "./GamePayTable";
/**
 * GameMiniPayTable.ts
 */
export class GameMiniPayTable extends GamePayTable {
    create() {
        super.create();
        MouseUtil.setInteractive(this.animation, true);
    }
    postCreate() {
        super.postCreate();
        Logger.addObjectRef(this, "MiniPayTable");
    }
    createCells() {
        this.cellTexts = [];
    }
    updatePrizeValueForCell(cellText, payoutMultiplier, stake) {
        return;
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerCore(AppEvent.IDLE, this.handleIdle);
        this.registerCore(AppEvent.BUSY, this.handleBusy);
        MouseUtil.addMouseUp(this.animation, this.handleMouseUp, this);
    }
    handleBusy() {
        MouseUtil.setInteractive(this.animation, false);
    }
    handleIdle() {
        MouseUtil.setInteractive(this.animation, true);
    }
    handleMouseUp() {
        this.dispatchGame(SlingoEvent.PAY_TABLE_OPEN);
    }
    handleRotate(event) {
        const data = event?.getCurrentTarget() || {};
        this.visible = this.renderer.isPortrait(data.forceOrientation);
        this.applyProperties();
        this.updateCellTextOrientation();
    }
}
//# sourceMappingURL=GameMiniPayTable.js.map